let splideInstance, mainSplideInstance;
let isSpliderActive = true;
let subOprionApiInvoked = false;
window.VDB_FILTER_SELECTED_VALUES = {
  choose_a_metal: "",
  supported_shape: "",
  accent_stone: "",
  accent_stone_size: "",
  accent_stone_quantity: '',
  accent_stone_origin: "",
  pro_id: 123456,
  pro_type: 'Ring',
  pro_title: 'Test product title',
  gorup_id: '',
};
window.CARET_SIZE = {};
let urlParams = new URLSearchParams(window.location.search);
let url = new URL(window.location.href);

let ringViewer, handViewer;
let intialCaretSlider = true;
let currentViewMode = 'slider'; // 'slider', 'ring', or 'hand'
let selectedSliderIndex = 0;
window.three_d_static_data = [
  {
    "pmat": {
      "14k_yellow_gold": "https://cdn.shopify.com/s/files/1/0913/9354/files/14K_Yellow_Gold.pmat?v=1749547377",
      "14k_white_gold": "https://cdn.shopify.com/s/files/1/0913/9354/files/14K_White_Gold.pmat?v=1749547377",
      "10k_yellow_gold": "https://cdn.shopify.com/s/files/1/0913/9354/files/10K_Yellow_Gold.pmat?v=1749547377",
      "10k_white_gold": "https://cdn.shopify.com/s/files/1/0913/9354/files/10K_White_Gold.pmat?v=1749547377",
      "10k_rose_gold": "https://cdn.shopify.com/s/files/1/0913/9354/files/10K_Rose_Gold.pmat?v=1749547377",
      "yellow" : "https://cdn.shopify.com/s/files/1/0913/9354/files/Yellow.pmat?v=1750856296",
      "white" : "https://cdn.shopify.com/s/files/1/0913/9354/files/White.pmat?v=1750856296",
      "rose" : "https://cdn.shopify.com/s/files/1/0913/9354/files/Rose.pmat?v=1750856296"
    },
    "dmat": "https://d2dtfeai6qg5ne.cloudfront.net/3D_Assets/TuttoTerra/Environment/diamond-m.dmat",
    "vjson": "https://cdn.shopify.com/s/files/1/0913/9354/files/TuttoTerr.vjson?v=1751622756"
  }
];

function FilterSelectedinit() {
  ProductsFilter();
  // Ringcustomizer();
  questionFormapi();
  dropHintFormapi();
}

function MetalChoose() {
  const variants = document.querySelectorAll(".Metal-Choose");
  variants.forEach(variant => {
    variant.addEventListener("click", () => {
      let inputvalue = variant.getAttribute("metals-name");
      if (!inputvalue) return;
      let formattedMetal = inputvalue.split(' ').join('-');
      localStorage.setItem("MetalChoose", inputvalue);
      window.VDB_FILTER_SELECTED_VALUES.choose_a_metal = inputvalue;
      console.log('======> click from the metal');
      ProductsSuboptionsFilter();
    });
  });
}

function SupportedShape() {
  const diamondShape = document.querySelectorAll(".diamond-shape");
  diamondShape.forEach(variant => {
    variant.addEventListener("click", () => {
      let inputvalue = variant.getAttribute("diamond-name");
      localStorage.setItem("diamondshape", inputvalue);
      window.VDB_FILTER_SELECTED_VALUES.supported_shape = inputvalue;
      console.log('======> click from the shape');
      
      ProductsSuboptionsFilter();
    });
  });
}

function AccentStone() {
  const accentstone = document.querySelectorAll(".accent-stone");
  accentstone.forEach(variant => {
    variant.addEventListener("click", () => {
      let inputvalue = variant.getAttribute("stone-name");
      localStorage.setItem("accentstone", inputvalue);
      window.VDB_FILTER_SELECTED_VALUES.accent_stone = inputvalue;
      console.log('======> click from the accent stone');
      
      ProductsSuboptionsFilter();
    });
  });
}

function AccentStoneSize() {
  const accentstonesize = document.querySelectorAll(".accent-stone-size");
  accentstonesize.forEach(variant => {
    variant.addEventListener("click", () => {
      let inputvalue = variant.getAttribute("size-name");
      let result = inputvalue.replace('.', '');
      let parts = result.split(' ');
      let formattedSize = parts.length > 1 ? `${parts[0]}-${parts[1]}` : parts[0];
      localStorage.setItem("accentstonesize", inputvalue);
      window.VDB_FILTER_SELECTED_VALUES.accent_stone_size = formattedSize;
      console.log('======> click from the accent stone size');
      
      ProductsSuboptionsFilter();
    });
  });
}

function AccentStoneQuantity() {
  const accentstonequantity = document.querySelectorAll(".diamond-size-quantity");
  accentstonequantity.forEach(variant => {
    variant.addEventListener("click", () => {
      let inputvalue = variant.getAttribute("sizequantit-name");
      localStorage.setItem("diamondsizequantity", inputvalue);
      window.VDB_FILTER_SELECTED_VALUES.accent_stone_quantity = inputvalue;
      console.log('======> click from the AccentStoneQuantity');
      ProductsSuboptionsFilter();
    });
  });
}

function AccentStoneOrigin() {
  const accentStoneorigin = document.querySelectorAll(".vdb-varriant-stones");
  accentStoneorigin.forEach(variant => {
    variant.addEventListener("click", () => {
      let inputvalue = variant.getAttribute("StoneOrigin-name");
      let parts = inputvalue.split(' ');
      let formattedOrigin = parts.length > 1 ? `${parts[0]}-${parts[1]}` : parts[0];
      localStorage.setItem("varriantstones", inputvalue);
      window.VDB_FILTER_SELECTED_VALUES.accent_stone_origin = formattedOrigin;
      console.log('======> click from the AccentStoneOrigin');
      ProductsSuboptionsFilter();
    });
  });
}

async function ProductsSuboptionsFilter() {

  if(subOprionApiInvoked) {
    return;
  }
  
  const filterValues = window.VDB_FILTER_SELECTED_VALUES;
  const formData = new FormData();
  formData.append("action", "fetch_sub_options");
  formData.append("shop", "macorina-joyeria-fina.myshopify.com");
  formData.append("group_id", window.VDB_FILTER_SELECTED_VALUES.gorup_id.toString());
  const attributeInfo = {
    "Shapes": filterValues.supported_shape,
    "Metal": filterValues.choose_a_metal,
    "Accent stones": filterValues.accent_stone,
    "Accent size": filterValues.accent_stone_size,
    "Side stone origin": filterValues.accent_stone_origin,
    "Side Stone Quantity": filterValues.accent_stone_quantity
  };

  formData.append("attribute_info", JSON.stringify(attributeInfo));
  console.log(JSON.stringify(attributeInfo));

  // Show skeleton loading state
  // document.querySelectorAll('.skeleton-loading').forEach(el => el.style.display = 'block');
  // document.querySelectorAll('.actual-content').forEach(el => el.style.display = 'none');

  try {
    subOprionApiInvoked = true;
    const response = await fetch('https://phpstack-998622-4818184.cloudwaysapps.com/frontend.php', {
      method: 'POST',
      body: formData
    });

    const text = await response.text();
    let jsonData;
    subOprionApiInvoked = false;
    try {
      jsonData = JSON.parse(text);
    } catch (jsonError) {
      throw new Error("Response is not valid JSON");
    }

    if (!jsonData || !jsonData.data || Object.keys(jsonData.data).length === 0) {
      throw new Error("Invalid response from the server");
    }

    // Update URL with product handle and variant ID
    const url = new URL(window.location.href);
    url.pathname = `/products/${jsonData.data.product_data.pro_handle}`;
    url.searchParams.set('variant', jsonData.data.product_data.variant_id);
    console.log('=====> url :::', url);

    setTimeout(()=> {
      window.history.replaceState({}, '', url.toString());
      updateAddtoCartUrl();
    }, 0)
    

    productdataset(jsonData.data.product_data);
    applySelections(jsonData.data.option_data);
    toggleView(currentViewMode);
    setupCaretSilder(jsonData.data.product_data);
    if (currentViewMode == 'ring') {
      if (!ringViewer) {
        init3DViewer();
      } else {
        updateRingViewer();
      }
    } else if (currentViewMode == 'hand') {
      if (!handViewer) {
        initHandViewer();
      } else {
        updateHandViewer();
      }
    }
    console.log("ProductsSubtn-settingboptionsFilter", jsonData.data.product_data)

    // Hide skeleton and show actual content
    // document.querySelectorAll('.skeleton-loading').forEach(el => el.style.display = 'none');
    // document.querySelectorAll('.actual-content').forEach(el => el.style.display = 'block');

  } catch (error) {
    console.error("Error fetching product data:", error.message);
    // Hide skeleton and show actual content even on error
    document.querySelectorAll('.skeleton-loading').forEach(el => el.style.display = 'none');
    document.querySelectorAll('.actual-content').forEach(el => el.style.display = 'block');
  }
}

async function ProductsFilter() {
  const url = window.location.href;
  const handle = url.split('/products/')[1]?.split('?')[0];
  const formData = new FormData();
  formData.append("action", "fetch_product_options");
  formData.append("shop", "macorina-joyeria-fina.myshopify.com");
  formData.append("handle", handle);

  // Show skeleton loading state
  document.querySelectorAll('.skeleton-loading').forEach(el => el.style.display = 'block');
  document.querySelectorAll('.actual-content').forEach(el => el.style.display = 'none');

  try {
    const response = await fetch('https://phpstack-998622-4818184.cloudwaysapps.com/frontend.php', {
      method: 'POST',
      body: formData
    });

    const text = await response.text();
    let jsonData;

    try {
      jsonData = JSON.parse(text);
    } catch (jsonError) {
      throw new Error("Response is not valid JSON");
    }

    if (!jsonData || !jsonData.data || Object.keys(jsonData.data).length === 0) {
      throw new Error("Invalid response from the server");
    }

    applySelections(jsonData.data.option_data);
    productdataset(jsonData.data.product_data);
    window.product_data = jsonData.data.product_data;
    window.VDB_FILTER_SELECTED_VALUES.gorup_id = jsonData.group_id;
    console.log("ProductsFilter", jsonData.data);
    setupCaretSilder(jsonData.data.product_data);

    hideSkeleton();
  } catch (error) {
    console.error("Error fetching product data:", error.message);
    // Hide skeleton and show actual content even on error
    document.querySelectorAll('.skeleton-loading').forEach(el => el.style.display = 'none');
    document.querySelectorAll('.actual-content').forEach(el => el.style.display = 'block');
  }
}

function updateSliderTrack(slider) {
  const percent = (slider.value - slider.min) / (slider.max - slider.min);
  slider.style.background = `linear-gradient(to right, #6aa96b 0%, #6aa96b ${percent * 100}%, #ddd ${percent * 100}%, #ddd 100%)`;
}

function setupCaretSilder(productData) {
  console.log('======> Product data :::', productData);
  console.log('======> Caret data :::', productData.carat_glbs);

  // Get caret slider container
  const caretSliderContainer = document.querySelector('.price_range.slidecontainer');
  
  // Check if carat_glbs is empty or doesn't exist
  if (!productData.carat_glbs || productData.carat_glbs.trim() === '') {
    if (caretSliderContainer) {
      caretSliderContainer.style.display = 'none';
    }
    console.log('No carat data available, hiding caret slider');
    return;
  }

  // Show skeleton for caret slider initially
  if (caretSliderContainer) {
    caretSliderContainer.style.display = 'block';
    const skeletonLoading = caretSliderContainer.querySelector('.skeleton-loading');
    const actualContent = caretSliderContainer.querySelector('.actual-content');
    
    if (skeletonLoading && actualContent) {
      skeletonLoading.style.display = 'block';
      actualContent.style.display = 'none';
      actualContent.classList.add('skeleton-hidden');
    }
  }

  const urls = productData.carat_glbs.split(',');
  window.CARET_SIZE = urls.reduce((obj, url) => {
    const m = url.match(/_(\d+\.\d+)CT\.glb$/);
    if (m) obj[m[1]] = url;
    return obj;
  }, {});

  // Check if we have any valid carat sizes after processing
  const keys = Object.keys(window.CARET_SIZE);
  if (keys.length === 0) {
    if (caretSliderContainer) {
      caretSliderContainer.style.display = 'none';
    }
    console.log('No valid carat sizes found, hiding caret slider');
    return;
  }

  // Setup caret slider
  const slider   = document.getElementById("myRange");
  const label    = document.getElementById("rangeValue");
  const spanMin  = document.getElementById("rangeMin");
  const spanMax  = document.getElementById("rangeMax");

  
  // Dynamically set slider attributes
  slider.min   = 0;
  slider.max   = keys.length - 1;
  slider.step  = 1;
  

  console.log('======> slider value :::', slider.value);

  let sliderValue = slider.value;  
  if(intialCaretSlider) {
    sliderValue = 0
  } 
  
  slider.value = sliderValue;
  const value = (slider.value - slider.min) / (slider.max - slider.min) * 100;
  slider.style.setProperty('--value', value + '%');
  updateSliderTrack(slider);
  

  // also display min/max if you like
  spanMin.textContent = `${keys[slider.min]}ct`;
  spanMax.textContent = `${keys[slider.max]}ct`;
   label.textContent = `${keys[slider.value]} Carat`;

  //Handle input of caret range
  function updateCaretSlider() {
    const idx   = Number(slider.value);
    const carat = keys[idx];
    label.textContent = `${carat} Carat`;
    intialCaretSlider = false;
    
    // Update the 3d view and hand view
    if (currentViewMode == 'ring') {
      if (!ringViewer) {
        init3DViewer();
      } else {
        updateRingViewer();
      }
    } else if (currentViewMode == 'hand') {
      if (!handViewer) {
        initHandViewer();
      } else {
        updateHandViewer();
      }
    }
  }

  slider.addEventListener("input", updateCaretSlider);
  document.querySelector('.caret-slider').style.display = currentViewMode !== 'slider' ? 'block' : 'none';
  
  // Hide skeleton and show actual content for caret slider
  setTimeout(() => {
    if (caretSliderContainer) {
      const skeletonLoading = caretSliderContainer.querySelector('.skeleton-loading');
      const actualContent = caretSliderContainer.querySelector('.actual-content');
      
      if (skeletonLoading && actualContent) {
        skeletonLoading.style.display = 'none';
        actualContent.style.display = 'block';
        actualContent.classList.remove('skeleton-hidden');
        actualContent.style.opacity = '1';
      }
    }
  }, 500); // Show caret slider after a short delay
  
}

function getGlbOfSelectedCaret() {
  const slider   = document.getElementById("myRange");
  const keys = Object.keys(window.CARET_SIZE);
  const idx   = Number(slider.value);
  const caret = keys[idx];
  const url = window.CARET_SIZE[caret];

  return url;
}

function applySelections(options) {
  const optionsLabel = [];
  options.forEach(option => {
    optionsLabel.push(option.label);
  });

  const containerList = {
    "Metal": "vdb-varriant-metal-container",
    "Shapes": "vdb-varriant-shape-container",
    "Accent stones": "vdb-varriant-accent-stone-container",
    "Accent size": "vdb-varriant-size-container",
    "Side Stone Quantity": "vdb-varriant-size-Quantit-container",
    "Side stone origin": "vdb-varriant-origin-container"
  }

  // hide the container if the label is not in the optionsLabel array
  Object.keys(containerList).forEach(key => {
    if (!optionsLabel.includes(key)) {
      document.querySelector(`#${containerList[key]}`).style.display = "none";
    }
  });

  options.forEach(option => {
    const label = option.label;
    const labeltext = option.description;
    const selected = option.selected;
    let datavalues = option.values;

    if (datavalues && typeof datavalues === 'object' && !Array.isArray(datavalues)) {
      datavalues = Object.values(datavalues);
    }

    if (!Array.isArray(datavalues)) {
      console.warn(" 'values' is not a valid array:", datavalues);
      return;
    }

    const labelicon = `
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M9 0.875C7.39303 0.875 5.82214 1.35152 4.486 2.24431C3.14985 3.1371 2.10844 4.40605 1.49348 5.8907C0.87852 7.37535 0.717618 9.00901 1.03112 10.5851C1.34463 12.1612 2.11846 13.6089 3.25476 14.7452C4.39106 15.8815 5.8388 16.6554 7.4149 16.9689C8.99099 17.2824 10.6247 17.1215 12.1093 16.5065C13.594 15.8916 14.8629 14.8502 15.7557 13.514C16.6485 12.1779 17.125 10.607 17.125 9C17.1227 6.84581 16.266 4.78051 14.7427 3.25727C13.2195 1.73403 11.1542 0.877275 9 0.875ZM9 15.875C7.64026 15.875 6.31105 15.4718 5.18046 14.7164C4.04987 13.9609 3.16868 12.8872 2.64833 11.6309C2.12798 10.3747 1.99183 8.99237 2.2571 7.65875C2.52238 6.32513 3.17716 5.10013 4.13864 4.13864C5.10013 3.17716 6.32514 2.52237 7.65876 2.2571C8.99238 1.99183 10.3747 2.12798 11.631 2.64833C12.8872 3.16868 13.9609 4.04987 14.7164 5.18045C15.4718 6.31104 15.875 7.64025 15.875 9C15.8729 10.8227 15.1479 12.5702 13.8591 13.8591C12.5702 15.1479 10.8227 15.8729 9 15.875ZM10.25 12.75C10.25 12.9158 10.1842 13.0747 10.0669 13.1919C9.94974 13.3092 9.79076 13.375 9.625 13.375C9.29348 13.375 8.97554 13.2433 8.74112 13.0089C8.5067 12.7745 8.375 12.4565 8.375 12.125V9C8.20924 9 8.05027 8.93415 7.93306 8.81694C7.81585 8.69973 7.75 8.54076 7.75 8.375C7.75 8.20924 7.81585 8.05027 7.93306 7.93306C8.05027 7.81585 8.20924 7.75 8.375 7.75C8.70652 7.75 9.02447 7.8817 9.25889 8.11612C9.49331 8.35054 9.625 8.66848 9.625 9V12.125C9.79076 12.125 9.94974 12.1908 10.0669 12.3081C10.1842 12.4253 10.25 12.5842 10.25 12.75ZM7.75 5.5625C7.75 5.37708 7.80499 5.19582 7.908 5.04165C8.01101 4.88748 8.15743 4.76732 8.32874 4.69636C8.50004 4.62541 8.68854 4.60684 8.8704 4.64301C9.05226 4.67919 9.2193 4.76848 9.35042 4.89959C9.48153 5.0307 9.57082 5.19775 9.60699 5.3796C9.64316 5.56146 9.6246 5.74996 9.55364 5.92127C9.48268 6.09257 9.36252 6.23899 9.20835 6.342C9.05418 6.44502 8.87292 6.5 8.6875 6.5C8.43886 6.5 8.20041 6.40123 8.02459 6.22541C7.84878 6.0496 7.75 5.81114 7.75 5.5625Z" fill="black"/>
        </svg>
        `;


    if (label == "Metal") {
      const metalslabeldiv = document.querySelector(".vdb-varriant_label");
      const metalsContainer = document.querySelector("#vdb-varriant-metal");
      metalsContainer.innerHTML = '';
      metalslabeldiv.innerHTML = '';

      const Metalsinnerlabel = `
                 <div class="tooltip">
                     <button class="tooltip-button">${labelicon}</button>
                     <div class="tooltip-text">
                         <h4>${label}</h4>
                         ${labeltext}
                     </div>
                 </div>
                 <p class="">
                     <p>${label}</p> :
                     <span >${selected}</span>
                 </p>
             `;

      metalslabeldiv.innerHTML = Metalsinnerlabel;

      datavalues.forEach((Metals, index) => {
        const metalswrapper = document.createElement("div");
        metalswrapper.className = "vdb-varriant-box";
        let metalstitle = Metals.split(' ')[0];
        let metalsname = Metals.split(' ')[1];

        let Metalsclass = ""
        if (metalsname === "Rose") {
          Metalsclass = "pink"
        } else if (metalsname === "White") {
          Metalsclass = "grey"
        } else if (metalsname === "Yellow") {
          Metalsclass = "yellow"
        }

        const Metalsinner = `
             <div class="vdb-varriant ${Metalsclass} Metal-Choose ${Metals === selected ? "active" : ""}" metals-name="${Metals}">
               <input type="radio" id="metal-${index}" name="metal" value="${Metals}" ${Metals === selected ? "checked" : ""}>
               <label for="metal-${index}">
                 ${metalstitle}
               </label>
             </div>
           `;

        metalswrapper.innerHTML = Metalsinner;
        metalsContainer.appendChild(metalswrapper);
      });
      // let formattedMetal = selected.split(' ').join('-');
      window.VDB_FILTER_SELECTED_VALUES.choose_a_metal = selected;
      MetalChoose();
    }

    if (label == "Shapes") {
      const shapesContainer = document.getElementById('vdb-varriant-shape');
      const shapeslabeldiv = document.querySelector(".vdb-varriant_label-Shape");
      shapesContainer.innerHTML = '';
      shapeslabeldiv.innerHTML = '';

      const Shapesinnerlabel = `
             <div class="tooltip">
                 <button class="tooltip-button">${labelicon}</button>
                 <div class="tooltip-text">
                     <h4>Formas</h4>
                     ${labeltext}
                 </div>
             </div>
             <p class="">
                 <p>Formas</p> :
                 <span>${selected}</span>
             </p>
         `;
      shapeslabeldiv.innerHTML = Shapesinnerlabel;

      datavalues.forEach((diamondShape, index) => {
        const wrapper = document.createElement("div");
        wrapper.className = "vdb-varriant-box";
        const inner = `
             <div class="vdb-varriant diamond-shape ${diamondShape === selected ? "active" : ""}" diamond-name="${diamondShape}">
               <input type="radio" id="stone-${index}" name="stone" value="${diamondShape}" ${diamondShape === selected ? "checked" : ""}>
               <label for="stone-${index}">
                 <img height="30px" width="30px" src="https://cdn.shopify.com/s/files/1/0913/9354/files/${diamondShape}.png" alt="${diamondShape} Shape">
               </label>
             </div>
           `;
        wrapper.innerHTML = inner;
        shapesContainer.appendChild(wrapper);
      });
      window.VDB_FILTER_SELECTED_VALUES.supported_shape = selected;
      SupportedShape();
    }

    if (label == "Accent stones") {
      const StoneContainer = document.querySelector("#vdb-varriant-stone");
      const stoneslabeldiv = document.querySelector(".vdb-varriant_label-diamond-Shape");
      StoneContainer.innerHTML = '';
      stoneslabeldiv.innerHTML = '';

      const accentstoneslabel = `
                <div class="tooltip">
                    <button class="tooltip-button">${labelicon}</button>
                    <div class="tooltip-text">
                        <h4>Piedras de acento</h4>
                        ${labeltext}
                    </div>
                </div>
                <p class="">
                    <p>Piedras de acento</p> :
                    <span>${selected}</span>
                </p>
            `;
      stoneslabeldiv.innerHTML = accentstoneslabel;

      datavalues.forEach((diamondStone, index) => {
        const wrapper = document.createElement("div");
        wrapper.className = "vdb-varriant-box";

        const inner = `
             <div class="vdb-varriant accent-stone ${diamondStone === selected ? "active" : ""}" Stone-name="${diamondStone}" >
               <input type="radio" id="stone-${index}" name="stone" value="${diamondStone}" ${diamondStone === selected ? "checked" : ""}>
               <label for="stone-${index}">
                 <img height="30px" width="30px" src="https://cdn.shopify.com/s/files/1/0913/9354/files/${diamondStone}.png" alt="${diamondStone} Shape">
               </label>
             </div>`;

        wrapper.innerHTML = inner;
        StoneContainer.appendChild(wrapper);
      });
      window.VDB_FILTER_SELECTED_VALUES.accent_stone = selected;
      AccentStone();
    }

    if (label == "Accent size") {
      const sizeContainer = document.querySelector("#vdb-varriant-size");
      const sizelabeldiv = document.querySelector(".vdb-varriant_label-diamond-size");
      sizeContainer.innerHTML = '';
      sizelabeldiv.innerHTML = '';

      const sizelabel = `
                 <div class="tooltip">
                     <button class="tooltip-button">${labelicon}</button>
                     <div class="tooltip-text">
                         <h4>Tamaño del acento</h4>
                         ${labeltext}
                     </div>
                 </div>
                 <p class="">
                     <p>Tamaño del acento</p> :
                     <span>${selected}</span>
                 </p>
             `;
      sizelabeldiv.innerHTML = sizelabel;

      datavalues.forEach((diamondsize, index) => {
        const wrapper = document.createElement("div");
        wrapper.className = "vdb-varriant-box";

        const inner = `
             <div class="vdb-varriant-size accent-stone-size ${diamondsize === selected ? "active" : ""}" size-name="${diamondsize}">
               <input type="radio" id="size-${index}" name="size" value="${diamondsize}" ${diamondsize === selected ? "checked" : ""}>
               <label for="size-${index}">
                 ${diamondsize}
               </label>
             </div>
           `;

        wrapper.innerHTML = inner;
        sizeContainer.appendChild(wrapper);
      });
      AccentStoneSize();
    }

    if (label == "Side Stone Quantity") {
      const sizeQuantitContainer = document.querySelector("#vdb-varriant-size-Quantit");
      const stonequantitylabeldiv = document.querySelector(".vdb-varriant_label-stone-quantity");
      sizeQuantitContainer.innerHTML = '';
      stonequantitylabeldiv.innerHTML = '';

      const stonequantity = `
                 <div class="tooltip">
                     <button class="tooltip-button">${labelicon}</button>
                     <div class="tooltip-text">
                         <h4>Cantidad de piedras laterales</h4>
                         ${labeltext}
                     </div>
                 </div>
                 <p class="">
                     <p>Cantidad de piedras laterales</p> :
                     <span>${selected}</span>
                 </p>
             `;
      stonequantitylabeldiv.innerHTML = stonequantity;

      datavalues.forEach((sizeQuantit, index) => {
        const wrapper = document.createElement("div");
        wrapper.className = "vdb-varriant-box";

        const inner = `
             <div class="vdb-varriant-size diamond-size-quantity  ${sizeQuantit === selected ? "active" : ""}" sizeQuantit-name="${sizeQuantit}">
               <input type="radio" id="size-${index}" name="size" value="${sizeQuantit}" ${sizeQuantit === selected ? "checked" : ""}>
               <label for="size-${index}">
                 ${sizeQuantit}
               </label>
             </div>
           `;

        wrapper.innerHTML = inner;
        sizeQuantitContainer.appendChild(wrapper);
      });
      AccentStoneQuantity();
    }

    if (label == "Side stone origin") {
      const naturalContainer = document.querySelector("#vdb-varriant-natural");
      const originlabeldiv = document.querySelector(".vdb-varriant_label-side-stones");
      naturalContainer.innerHTML = '';
      originlabeldiv.innerHTML = '';

      const originlabel = `
                 <div class="tooltip">
                     <button class="tooltip-button">${labelicon}</button>
                     <div class="tooltip-text">
                         <h4>Origen de la piedra lateral</h4>
                         ${labeltext}
                     </div>
                 </div>
                 <p class="">
                     <p>Origen de la piedra lateral</p> :
                     <span>${selected}</span>
                 </p>
             `;
      originlabeldiv.innerHTML = originlabel;

      datavalues.forEach((natural, index) => {
        const wrapper = document.createElement("div");
        wrapper.className = "vdb-varriant-box";

        const inner = `
             <div class="vdb-varriant-stones ${natural === selected ? "active" : ""}" StoneOrigin-name="${natural}">
               <input type="radio" id="${natural}" name="natural" value="${natural}" ${natural === selected ? "checked" : ""}>
               <label for="${natural}">
                 <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                 <path d="M7.02681 5.558L9.56181 0.5H10.4388L12.9728 5.558H7.02681ZM9.55681 16.677L1.02981 6.442H9.55881L9.55681 16.677ZM10.4418 16.677V6.442H18.9718L10.4418 16.677ZM13.9498 5.557L11.4268 0.5H16.6918L19.2218 5.558L13.9498 5.557ZM0.778809 5.557L3.30781 0.5H8.57281L6.04981 5.558L0.778809 5.557Z" fill="black">
                 </path></svg>
                 ${natural}
               </label>
             </div>
           `;
        wrapper.innerHTML = inner;
        naturalContainer.appendChild(wrapper);
      });
      let parts = selected.split(' ');
      AccentStoneOrigin();
    }
  });
}

function productdataset(product) {
  const vbdproducsku = document.querySelector('.product-sku-id');
  const producttitle = document.querySelector('.product-title-text');
  const vbdproducprice = document.querySelector('.vdb-product-price');
  const vbdproducvariant = document.querySelector('.vdb-product-variant-id');

  vbdproducvariant.setAttribute("variant-id", product.variant_id);
  producttitle.textContent = product.prod_title || '';
  vbdproducprice.textContent = product.price || '';
  vbdproducsku.textContent = product.product_id || '';
  
  vdbSetUrlParams("variant", product.variant_id)

  let imageUrls = product?.images?.split(',');

  // imageUrls = [
  //   "https://cdn.shopify.com/s/files/1/0913/9354/files/Rectangle_4_9acb6827-55bf-4a9c-9331-ba913e99ae22.png?v=1728499242",
  //   "https://cdn.shopify.com/s/files/1/0913/9354/files/Rectangle_4_9acb6827-55bf-4a9c-9331-ba913e99ae22.png?v=1728499242",
  //   "https://cdn.shopify.com/s/files/1/0913/9354/files/Rectangle_4_9acb6827-55bf-4a9c-9331-ba913e99ae22.png?v=1728499242"
  // ]

  const sliderImages = document.querySelectorAll('.vdb-slider img');
  const sliderNavImages = document.querySelectorAll('.vdb-slider-nav img');

  console.log("======> image count :::", imageUrls);

  const vdbSlider = document.querySelector('.vdb-slider');
  const vdbSliderNav = document.querySelector('.vdb-slider-nav');

  if (imageUrls.length == 1 && imageUrls[0] == '') {
    imageUrls = ["https://cdn.shopify.com/s/files/1/0913/9354/files/no-image.webp?v=1744957723"];
    initSlider(imageUrls, true);
  } else {
    initSlider(imageUrls);
  }



}

function dropHintFormapi() {
  const dropHintForm = document.getElementById("dropHintForm");
  dropHintForm.addEventListener("submit", async function (e) {
    e.preventDefault();
    const form = e.target;
    const data = new FormData();

    data.append("action", "drop_hint");
    data.append("shop", "macorina-joyeria-fina.myshopify.com");
    data.append("your_name", form.your_name.value);
    data.append("your_email", form.your_email.value);
    data.append("your_phone", form.your_phone.value);
    data.append("recipient_name", form.recipient_name.value);
    data.append("email", form.email.value);
    data.append("share_message", form.share_message.value);
    data.append("url", window.location.href);

    console.log("data:", {
      your_name: form.your_name.value,
      your_email: form.your_email.value,
      your_phone: form.your_phone.value,
      recipient_name: form.recipient_name.value,
      email: form.email.value,
      share_message: form.share_message.value,
      url: window.location.href
    });

    try {
      const response = await fetch("https://phpstack-998622-4818184.cloudwaysapps.com/frontend.php", {
        method: "POST",
        body: data
      });
      const result = await response.json();
      console.log(result.message);
      closeModel("Drop-Hint-open-conta");

    } catch (error) {
      console.error("Error submitting Drop a Hint form:", error);
    }
  });
}

function questionFormapi() {
  const questionForm = document.getElementById("questionForm");
  questionForm.addEventListener("submit", async function (e) {
    e.preventDefault();
    const form = e.target;
    const data = new FormData();

    data.append("shop", "macorina-joyeria-fina.myshopify.com");
    data.append("product", window.VDB_FILTER_SELECTED_VALUES?.pro_title || "");
    data.append("pro_id", window.VDB_FILTER_SELECTED_VALUES?.pro_id || "");
    data.append("pro_type", window.VDB_FILTER_SELECTED_VALUES?.pro_type || "");
    data.append("name", form.name.value);
    data.append("email", form.email.value);
    data.append("mobile_country_code", form.mobile_country_code.value);
    data.append("mobile", form.mobile.value);
    data.append("message", form.message.value);

    console.log("data:", {
      product: window.VDB_FILTER_SELECTED_VALUES?.pro_title,
      pro_id: window.VDB_FILTER_SELECTED_VALUES?.pro_id,
      pro_type: window.VDB_FILTER_SELECTED_VALUES?.pro_type,
      name: form.name.value,
      email: form.email.value,
      mobile_country_code: form.mobile_country_code.value,
      mobile: form.mobile.value,
      message: form.message.value
    });

    try {
      const response = await fetch("https://phpstack-998622-4818184.cloudwaysapps.com/frontend.php", {
        method: "POST",
        body: data
      });

      const rawResponse = await response.text();

      if (rawResponse) {
        try {
          const json = JSON.parse(rawResponse);
          console.log("Parsed JSON response:", json);
        } catch (e) {
          console.warn("Non-JSON response:", rawResponse);
        }
      } else {
        console.warn("Empty response from server.");
      }
      closeModel("Email-open-conta");
    } catch (error) {
      console.error("Error submitting", error);
    }

  });
}

function Ringcustomizer() {
  const selectElement = document.querySelector('.vdb-varriant-size-later select');

  function updateRingCustomizer() {
    let selectElementValue = '';
    const selectedValue = selectElement.value || false;
    selectElementValue = selectedValue === false ? false : true;

    localStorage.setItem("SelectRingSize", selectElementValue);
  }
  selectElement.addEventListener('change', updateRingCustomizer);
  updateRingCustomizer();
}

function updateAddtoCartUrl() {
  const naturalStockNum = url.searchParams.get("natural_stock_num");
  const labgrownStockNum = url.searchParams.get("labgrown_stock_num");
  const btnsetting = document.querySelector('.btn-setting');
  const hasStockNum = !!naturalStockNum || !!labgrownStockNum;
  const handle = window.location.href.split('/products/')[1]?.split('?')[0];
  const settingVariant = url.searchParams.get("variant");
  const settingRingSize = getQueryParam("setting-ring-size") || '' ;
  
  
  if (hasStockNum) {
    btnsetting.href = `/products/${handle}?variant=${settingVariant}&setting-handle=${handle}&setting-ring-size=${settingRingSize}`;

    if (naturalStockNum) {
      btnsetting.href += `&natural_stock_num=${naturalStockNum}`;
    } else {
      btnsetting.href += `&labgrown_stock_num=${labgrownStockNum}`;
    }
  } else {
    const handle = window.location.href.split('/products/')[1]?.split('?')[0];
    btnsetting.href = `/collections/stones?setting-handle=${handle}&variant=${settingVariant}&setting-ring-size=${settingRingSize}`
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const Diamondshape = localStorage.getItem("diamondshape");
  const MetalChooseVal = localStorage.getItem("MetalChoose");
  const AccentStoneVal = localStorage.getItem("accentstone");
  const SelectRingSize = localStorage.getItem("SelectRingSize");
  const btnsetting = document.querySelector('.btn-setting');


  if (Diamondshape) {
    window.VDB_FILTER_SELECTED_VALUES.supported_shape = Diamondshape;
  }

  if (MetalChooseVal) {
    window.VDB_FILTER_SELECTED_VALUES.choose_a_metal = MetalChooseVal;
  }

  if (AccentStoneVal) {
    window.VDB_FILTER_SELECTED_VALUES.accent_stone = AccentStoneVal;
  }

  const naturalStockNum = url.searchParams.get("natural_stock_num");
  const labgrownStockNum = url.searchParams.get("labgrown_stock_num");
  const settingHandle = url.searchParams.get("setting-handle");
  const settingVariant = url.searchParams.get("variant");
  const settingViewMode = url.searchParams.get("settingView");


  const handle = window.location.href.split('/products/')[1]?.split('?')[0];

  const vdbSettingsbg = document.querySelector('.vdb-preview-details');
  const vdbSettingsDetails = document.querySelector('.vdb-settings-details');
  const productRingCustomizer = document.querySelector('#product-ring-customizer');
  const addtocartbtn = document.querySelector('#stone-pdp-add-to-cart');
  const Anillocompletobtn = document.querySelector('#Anillo_completo_btn');

  const hasStockNum = !!naturalStockNum || !!labgrownStockNum;

  // update cart url 
  updateAddtoCartUrl();
  
  // if (hasStockNum) {
  //   btnsetting.href = `/products/${handle}?variant=${settingVariant}&setting-handle=${handle}`;

  //   if (naturalStockNum) {
  //     btnsetting.href += `&natural_stock_num=${naturalStockNum}`;
  //   } else {
  //     btnsetting.href += `&labgrown_stock_num=${labgrownStockNum}`;
  //   }
  // } else {
  //   const handle = window.location.href.split('/products/')[1]?.split('?')[0];
  //   btnsetting.href = `/collections/stones?setting-handle=${handle}&variant=${settingVariant}`
  // }


  if (!(settingHandle && hasStockNum && !settingViewMode)) {
    vdbSettingsDetails.style.display = 'block';
    vdbSettingsbg.style.display = 'none';
    productRingCustomizer.style.display = 'none';
    addtocartbtn.style.display = 'block';
    Anillocompletobtn.style.display = 'none';
  } else {
    vdbSettingsDetails.style.display = 'none';
    vdbSettingsbg.style.display = 'block';
    productRingCustomizer.style.display = 'block';
    addtocartbtn.style.display = 'none';
    Anillocompletobtn.style.display = 'block';

    

    const waitForEvent = (eventName) =>
      new Promise((resolve) => {
        window.addEventListener(eventName, resolve, { once: true });
      });

    Promise.all([
      waitForEvent('STONE_DATA_READY'),
      waitForEvent('SETTING_DATA_READY')
    ]).then(([e1, e2]) => {
      let settingDetails = window.SETTING_DATA;
      const settingTitle = document.querySelector('#product-setting-name');
      const settingPrice = document.querySelector('#product-setting-price');
      const settingImage = document.querySelector('#product-setting-image');

      settingTitle.innerHTML = settingDetails.title;
      settingPrice.innerHTML = `$ ${settingDetails.price} MXN`;
      settingImage.src = settingDetails.image;

      const diamondTitle = document.querySelector('#product-diamond-name');
      const diamondPrice = document.querySelector('#product-diamond-price');
      const diamondImage = document.querySelector('#product-item-img');
      let stoneDetails = window.STONE_DATA;

      diamondTitle.innerHTML = `${stoneDetails.size}ct ${stoneDetails.shape} Diamond`;
      diamondPrice.innerHTML = `$ ${stoneDetails.total_sales_price} MXN`;
      diamondImage.src = stoneDetails.image_thumb_url;

      const totalPrice = document.querySelector('#product-total-price');
      totalPrice.innerHTML = `$ ${parseFloat(parseFloat(stoneDetails.total_sales_price) + parseFloat(settingDetails.price)).toFixed(2)} MXN`;

    });
  }


  FilterSelectedinit();
});


async function addToShopifyCart(variantId, retryCount = 0, maxRetries = 5) {
  try {
    let stoneDetails = window.STONE_DATA;
    const settingVariant = url.searchParams.get("variant");
    const selectedEngravingOption = document.querySelector('input[name="engraving"]:checked')?.value;
    const engravingText = document.getElementById('engraving-text')?.value;
    const groupTimeStamp = Date.now(); 
    const settingProperties =  {
          "ring_size": getQueryParam('setting-ring-size' || "Elegir talla después"),
          "engraving_selected_option": selectedEngravingOption,
          _group: groupTimeStamp
    }
    if (selectedEngravingOption == 'yes') {
      settingProperties['engraving'] = engravingText;
    }
  
    const formData = {
      items: [{
        id: parseInt(variantId),
        quantity: 1,
        properties: {
          _group: groupTimeStamp,
          _stone_group: stoneDetails?.group || '',
          "_stock_num": stoneDetails.stock_num,
          "_diamond_type": stoneDetails.type,
        }
      },
      {
        id: parseInt(settingVariant),
        quantity: 1,
        properties: settingProperties
      }
      ]
    };
    console.log(formData);
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(formData)
    });

    const result = await response.json();

    if (response.ok) {
      return result;
    } else {
      // If the response is not ok but we got JSON, it might contain error details
      throw new Error(result.description || 'Failed to add to cart');
    }
  } catch (error) {
    console.error('Cart error:', error);
    if (retryCount < maxRetries) {
      // Wait for exponential backoff time before retrying
      const waitTime = Math.min(1000 * Math.pow(2, retryCount), 10000);
      console.log(`Retrying cart add in ${waitTime}ms... (Attempt ${retryCount + 1} of ${maxRetries})`);
      await new Promise(resolve => setTimeout(resolve, waitTime));

      // Retry the request
      return addToShopifyCart(variantId, retryCount + 1, maxRetries);
    } else {
      throw new Error(`Failed to add to cart after ${maxRetries} retries: ${error.message}`);
    }
  }
}

 function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

// Function to handle Add to Cart button click
async function handleAddToCart() {
  let stoneDetails = window.STONE_DATA;
  console.log('======> Stone data :::',window.STONE_DATA );
  let isError = false;
  if (!stoneDetails) {
    console.error('No product data available');
    isError = true;
  }

  // Check ring size
  const ringSize = getQueryParam("setting-ring-size");
  const selectLaterCheckbox = document.querySelector('#choose-later-checkbox');
  if (!ringSize && !selectLaterCheckbox.checked) {
    document.querySelector("[ring-size-require-message]").style.display = 'block';
    isError = true;
  } else  {
    document.querySelector("[ring-size-require-message]").style.display = 'none';
  }

  // Check engraving part
  const selectedEngravingOption = document.querySelector('input[name="engraving"]:checked')?.value;
  console.log('======>selectedEngravingOption ::: ', selectedEngravingOption);
  if(!selectedEngravingOption) {
    document.querySelector("[engraving-reqired-message]").style.display = 'block';
    isError = true;
  } else if (selectedEngravingOption && selectedEngravingOption == 'yes') {
      const engravingText = document.getElementById('engraving-text')?.value;
      if(!engravingText) {
        isError = true;
        document.querySelector("[engraving-text-reqired-message]").style.display = 'block';
      } else {
        isError = false;
        document.querySelector("[engraving-text-reqired-message]").style.display = 'none';
      }
  } else {
    isError = false;
    document.querySelector("[engraving-text-reqired-message]").style.display = 'none';
    document.querySelector("[engraving-reqired-message]").style.display = 'none';
  }

  if(isError) {
    return;
  }

  const naturalStockNum = getQueryParam('natural_stock_num');
  const labgrownStockNum = getQueryParam('labgrown_stock_num');

  const productTitle = stoneDetails.shape ? `${stoneDetails.size}ct ${stoneDetails.shape} Diamond` : 'Diamond';
  const productPrice = stoneDetails.total_sales_price || 0;
  const imageUrls = stoneDetails.media.filter(item => item.type === 'image' && item.link).map(item => item.link);
  const productImage = imageUrls && imageUrls[0] ? imageUrls[0] : '';
  const stockId = stoneDetails.id || '';
  const nivodaLabType = 'false';

  // Show loading state
  const addToCartBtn = document.querySelector('#Anillo_completo_btn-setting');
  const originalBtnText = addToCartBtn.textContent;
  addToCartBtn.textContent = 'Añadiendo al carrito...';
  addToCartBtn.disabled = true;

  try {
    const formData = new URLSearchParams();
    formData.append('action', 'add_product_info');
    formData.append('shop', 'macorina-joyeria-fina.myshopify.com');
    if (naturalStockNum) {
      formData.append('natural_stock_num', naturalStockNum);
    } else if (labgrownStockNum) {
      formData.append('labgrown_stock_num', labgrownStockNum);
    }
    formData.append('product_title', productTitle);
    formData.append('product_price', productPrice);
    formData.append('stock_id', stockId);
    formData.append('prod_img', productImage);
    formData.append('nivoda_lab_type', nivodaLabType);

    // First API call to get variant ID
    const response = await fetch('https://phpstack-998622-4818184.cloudwaysapps.com/frontend.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData.toString()
    });

    if (!response.ok) {
      console.error('API Error:', {
        status: response.status,
        statusText: response.statusText
      });
      throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();
    console.log('API Response:', result);

    if (result.success && result.data.var_id) {
      console.log('Variant ID received:', result.data.var_id);
      // Add to Shopify cart with retry mechanism
      await addToShopifyCart(result.data.var_id);

      // Redirect to cart page after successful addition
      window.location.href = window.Shopify.routes.root + 'cart';
    } else {
      console.error('API Error Details:', {
        success: result.success,
        message: result.message,
        data: result.stoneDetails
      });
      throw new Error(result.message || 'Failed to get variant ID');
    }
  } catch (error) {
    console.error('Error adding product to cart:', error);
    // Show error message to user
    addToCartBtn.textContent = 'Failed to Add';
    alert('Error adding to cart: ' + error.message);
    setTimeout(() => {
      addToCartBtn.textContent = originalBtnText;
      addToCartBtn.disabled = false;
    }, 2000);
  }
}

function viewimgopen() {
  const viewimg = document.querySelector('._view_img');
  const viewimgopenconta = document.querySelector('.view_img_open_conta');

  if (!viewimg || !viewimgopenconta) {
    console.warn('Required elements not found');
    return;
  }

  viewimg.addEventListener('click', function (e) {
    e.stopPropagation();
    const isVisible = viewimgopenconta.style.display === 'block';
    viewimgopenconta.style.display = isVisible ? 'none' : 'block';
    document.documentElement.style.overflowY = isVisible ? 'auto' : 'hidden';
  });

  document.addEventListener('click', function (event) {
    if (
      !viewimgopenconta.contains(event.target) &&
      !viewimg.contains(event.target)
    ) {
      viewimgopenconta.style.display = 'none';
      document.documentElement.style.overflowY = 'auto';
    }
  });
}

function initSlider(images, isNoImage = false) {
  const list = document.getElementById('carousel-splide-list');
  const mainList = document.getElementById('main-splide-list');
  const sliderContainer = document.querySelector('.vdb-slider');
  const splideList = document.querySelector('.splide__list');

  // Create viewer containers if they don't exist
  if (!document.getElementById('ring-viewer-container')) {
    const viewerHTML = `
      <!-- Ring Viewer Container -->
      <div id="ring-viewer-container" class="viewer-container" style="display: none">
        <div id="ring-viewer-loader" class="loader"></div>
        <canvas id="ring-viewer-canvas" class="webgl-canvas"></canvas>
      </div>
      
      <!-- Hand Viewer Container -->
      <div id="hand-viewer-container" class="viewer-container" style="display: none">
        <div id="hand-viewer-loader" class="loader"></div>
        <canvas id="hand-viewer-canvas" class="webgl-canvas"></canvas>
      </div>
    `;
    splideList.insertAdjacentHTML('afterend', viewerHTML);
  }

  // Clear existing slides
  list.innerHTML = '';
  mainList.innerHTML = '';
  
  // Add images to slider
  images.forEach(img => {
    const mainLi = document.createElement('li');
    mainLi.className = 'splide__slide';
    mainLi.innerHTML = `<img src="${img}" alt="" onerror="this.src='https://cdn.shopify.com/s/files/1/0913/9354/files/no-image.webp?v=1744957723'">`;
    mainList.appendChild(mainLi);
  });

  if (mainSplideInstance) mainSplideInstance.destroy();
  if (splideInstance) splideInstance.destroy();

  mainSplideInstance = new Splide('#main-carousel', {
    type: 'fade',
    rewind: true,
    pagination: false,
    arrows: false,
  });

  
  if (!isNoImage) {
    images.forEach((img, i) => {
      const li = document.createElement('li');
      li.className = 'splide__slide';
      li.innerHTML = `<img src="${img}" alt="" onerror="this.src='https://cdn.shopify.com/s/files/1/0913/9354/files/no-image.webp?v=1744957723'">`;
      li.addEventListener('click', () => {
        console.log('Clicked image:', i);
          splideInstance.index = i;
          selectedSliderIndex = i;
          toggleView("slider");
      });
      
      list.appendChild(li);
    });

    splideInstance = new Splide('#thumbnail-carousel', {
      fixedWidth: 115,
      fixedHeight: 100,
      gap: 10,
      rewind: true,
      pagination: false,
      isNavigation: true,
      arrows: false,
      breakpoints: {
        1024: { perPage: 5 },
        768: { perPage: 4 },
        480: { perPage: 3 },
      },
    });
    if (splideInstance) {
        splideInstance.on( 'move', function () {
          console.log('========> selected index move event');
          selectedSliderIndex = splideInstance.index;
        });
      
        mainSplideInstance.sync(splideInstance);
       splideInstance.mount();
    }
   
  }
  mainSplideInstance.mount();

  splideInstance.go(selectedSliderIndex);
}

function toggleView(viewMode) {
  console.log('=======clicking in view :::' , viewMode);
  if(isSpliderActive && viewMode == 'slider') {
    return;
  }
  currentViewMode = viewMode;
  // Update UI
  document.getElementById('main-splide-list').style.display = viewMode === 'slider' ? 'block' : 'none';
  document.getElementById('ring-viewer-container').style.display = viewMode === 'ring' ? 'block' : 'none';
  document.getElementById('hand-viewer-container').style.display = viewMode === 'hand' ? 'block' : 'none';
  document.querySelector('.caret-slider').style.display = viewMode !== 'slider' ? 'block' : 'none';
  
  
  document.getElementById('3d-view-btn').classList.toggle('active', viewMode === 'ring');
  document.getElementById('hand-view-btn').classList.toggle('active', viewMode === 'hand');
  mainSplideInstance.Components.Drag.disable(true);
  isSpliderActive = false;
   if (viewMode === 'ring') {
     isSpliderActive = false;
      if (!ringViewer) {
        init3DViewer();
      } else {
        updateRingViewer();
      }
    } else if (viewMode === 'hand') {
      if (!handViewer) {
        initHandViewer();
      } else {
        updateHandViewer();
      }
    } else if (viewMode === 'slider') {
       isSpliderActive = true;
       const images = Array.from(document.querySelectorAll('#main-splide-list img')).map(img => img.src);
       initSlider(images);
       mainSplideInstance.Components.Drag.disable(false);

    }
}

function init3DViewer() {
  // Initialize the 3D viewer
  // You'll need to implement this based on your 3D viewer setup
  console.log("Initializing 3D viewer");
  
  // Get current product options from your UI
  const selectedMetal = ((document.querySelector('input[name="metal"]:checked').value).toLowerCase()).replace(/ /g, "_").split('_')[1] || '10k_white_gold';
  const selectedShape = document.querySelector('input[name="stone"]:checked').value || 'round';
  const three_d_static_data= window.three_d_static_data;
  
  console.log('=======> selected metal from 3D ::', selectedMetal);

  // You'll need to adapt this to match your actual product options
  const metalHead = three_d_static_data[0]['pmat'][selectedMetal];
  const diamondMat = three_d_static_data[0]['dmat'];
  const productData = window.product_data;
  // This is simplified - you'll need to adjust based on your actual model paths
  const headUrl = getGlbOfSelectedCaret();
  const shankUrl = productData.shank_glb;
  
  const mediaArray = generateThreeDMediaArray(headUrl, shankUrl, metalHead, metalHead, diamondMat, false);
  
  document.getElementById('ring-viewer-loader').style.display = 'block';
  
  // Initialize the viewer
  ringViewer = new webglPlayer();
  ringViewer.init('ring-viewer-canvas', mediaArray);
  
  setTimeout(() => {
    document.getElementById('ring-viewer-loader').style.display = 'none';
    // ringViewer.changeCameraAngle(9.032148130941792, 3.279103925163492, -5.131929721793564);
  }, 2000);
}

function initHandViewer() {
  // Similar to init3DViewer but with hand model
  console.log("Initializing hand viewer");
  
  const selectedMetal = ((document.querySelector('input[name="metal"]:checked').value).toLowerCase()).replace(/ /g, "_").split('_')[1] || 'white';
  const selectedShape = document.querySelector('input[name="stone"]:checked').value || 'round';
   const three_d_static_data= window.three_d_static_data;
  const productData = window.product_data;
  const metalHead = three_d_static_data[0]['pmat'][selectedMetal];
  const diamondMat = three_d_static_data[0]['dmat'];
  
  // This is simplified - you'll need to adjust based on your actual model paths
  const headUrl = getGlbOfSelectedCaret();
  const shankUrl = productData.shank_glb;
  
  const mediaArray = generateThreeDMediaArray(headUrl, shankUrl, metalHead, metalHead, diamondMat, true);
  
  document.getElementById('hand-viewer-loader').style.display = 'block';
  
  handViewer = new webglPlayer();
  handViewer.init('hand-viewer-canvas', mediaArray);
  
  setTimeout(() => {
    document.getElementById('hand-viewer-loader').style.display = 'none';
    // handViewer.changeCameraAngle(9.032148130941792,3.279103925163492,-5.131929721793564);
    //handViewer.changeCameraAngle(-8.947177237625846,1.6090838458187038,5.541607057625095);
    handViewer.changeCameraAngle(7.110059527876345,2.907456726720553,-7.410175249375942);
    
  }, 2000);
}

function updateRingViewer() {
  if (!ringViewer) return;
  
  const selectedMetal = ((document.querySelector('input[name="metal"]:checked').value).toLowerCase()).replace(/ /g, "_").split('_')[1] || 'white';
  const selectedShape = document.querySelector('input[name="stone"]:checked').value || 'round';
  const three_d_static_data = window.three_d_static_data;
  const productData = window.product_data;

  console.log('=======> selected metal from 3D ::', selectedMetal);

  const metalHead = three_d_static_data[0]['pmat'][selectedMetal];
  const diamondMat = three_d_static_data[0]['dmat'];
  const headUrl = getGlbOfSelectedCaret();
  const shankUrl = productData.shank_glb;
  
  const mediaArray = generateThreeDMediaArray(headUrl, shankUrl, metalHead, metalHead, diamondMat, false);
  
  document.getElementById('ring-viewer-loader').style.display = 'block';
  ringViewer.update('ring-viewer-canvas', mediaArray);
  
  setTimeout(() => {
    document.getElementById('ring-viewer-loader').style.display = 'none';
  }, 1000);
}

// New updateHandViewer function
function updateHandViewer() {
  if (!handViewer) return;
  
  const selectedMetal = ((document.querySelector('input[name="metal"]:checked').value).toLowerCase()).replace(/ /g, "_").split('_')[1] || 'white';
  const selectedShape = document.querySelector('input[name="stone"]:checked').value || 'round';
  const three_d_static_data = window.three_d_static_data;
  const productData = window.product_data;

  const metalHead = three_d_static_data[0]['pmat'][selectedMetal];
  const diamondMat = three_d_static_data[0]['dmat'];
  const headUrl = getGlbOfSelectedCaret();
  const shankUrl = productData.shank_glb;
  
  const mediaArray = generateThreeDMediaArray(headUrl, shankUrl, metalHead, metalHead, diamondMat, true);
  
  document.getElementById('hand-viewer-loader').style.display = 'block';
  handViewer.update('hand-viewer-canvas', mediaArray);
  
  setTimeout(() => {
    document.getElementById('hand-viewer-loader').style.display = 'none';
  }, 1000);
}

class webglPlayer 
{
            pureWhiteBg = true;
            jsonData = [];
            modelPaths = {};
            cModelPaths = {};
            models = {};
            parts = [];
            root;
            viewerLoaded = false;
            viewer = null;
            vjsonFile = '';
            rootScaleFactor = 1 / 10.0;
            devicePixelRatio = 2;

            constructor() {}

            init(id, data) {
                this.resetAllVariables();
                
                const canvas = document.getElementById(id);
                canvas.width = canvas.offsetWidth;
                canvas.height = 400; // Fixed height for our container

                this.jsonData = data;
                this.vjsonFile = three_d_static_data[0]['vjson'];
                
                document.getElementById(id.replace('canvas', 'loader')).style.display = 'block';

                setupCoreWebGlViewer(
                { canvas },
                { depthTonemap: this.pureWhiteBg }
                ).then(async (viewer) => {
                this.viewer = viewer;
                this.viewer.renderEnabled = false;
                this.setupThreeDCanvas(viewer);
                await this.afterInitViewer(viewer);
                this.viewer.scene.modelRoot.scale.setScalar(0.05); 
                this.viewer.renderEnabled = true;
                await this.viewer.addPlugin(CameraViewPlugin);

                document.getElementById(id.replace('canvas', 'loader')).style.display = 'none';
                });
            }

            async update(id, data) {
                this.jsonData = data;
                this.vjsonFile = three_d_static_data[0]['vjson'];
                
                document.getElementById(id.replace('canvas', 'loader')).style.display = 'block';

                this.generateModelPaths();
                await this.updateModels();

                document.getElementById(id.replace('canvas', 'loader')).style.display = 'none';
            }

            generateModelPaths() {
                this.jsonData.forEach(d => {
                if (d.option_type == 'model') {
                    this.modelPaths[d.option_identifier] = d.option_value;
                    if(!this.cModelPaths[d.option_identifier]) this.cModelPaths[d.option_identifier] = '';
                    if(!this.models[d.option_identifier]) this.models[d.option_identifier] = null;
                    if (!this.parts.includes(d.option_identifier)) this.parts.push(d.option_identifier);
                }
                })
            }

            async setMetalMaterial(colorFile, namingConvention) {
                const metalMaterial = await this.viewer
                .getManager()
                .importer.importSinglePath(colorFile);
                let objs = [];
                namingConvention = namingConvention.split(',').map(name => name.trim()) || [];

                objs = this.parts.map(part => this.models[part]);
                if (!objs.length) return;

                objs.forEach(obj => {
                obj.modelObject.traverse((o) => {
                    if (!o || !o.material) return;
                    if (!o.userData.originalMaterialName) o.userData.originalMaterialName = o.material.name;
                    if (namingConvention.includes(o.userData.originalMaterialName)) {
                    o.setMaterial(metalMaterial);
                    }
                });
                this.viewer.scene.setDirty({ sceneUpdate: true });
                });
            }

            async setDiamondMaterial(colorFile, namingConvention) {
                const diamondMaterial = await this.viewer
                .getManager()
                .importer.importSinglePath(colorFile);
                let objs = [];
                namingConvention = namingConvention.split(',').map(name => name.trim()) || [];

                objs = this.parts.map(part => this.models[part]);
                if (!objs.length) return;
                objs.forEach(obj => {
                obj.modelObject.traverse((o) => {
                    if (!o || !o.material) return;
                    if (!o.userData.originalMaterialName) o.userData.originalMaterialName = o.material.name;
                    if (namingConvention.includes(o.userData.originalMaterialName)) {
                    this.viewer.getPluginByType("Diamond").prepareDiamondMesh(o, { cacheKey: o.material.name, normalMapRes: 512 });
                    o.setMaterial(diamondMaterial);
                    }
                });
                this.viewer.scene.setDirty({ sceneUpdate: true });
                });
            }

            async afterInitViewer() {
                await this.viewer.getManager().addFromPath(this.vjsonFile);	
                this.viewer.getPlugin(InteractionPromptPlugin).enabled = false;
                this.root = await this.viewer.createObject3D();
                this.viewerLoaded = true;        
                this.generateModelPaths();
                await this.updateModels();
            }
            
            async updateModels() {
                let viewer = this.viewer;
                if (!viewer || !this.viewerLoaded) return;
                const manager = viewer.getPlugin(AssetManagerPlugin);
                await Promise.all(this.parts.map(async part => {
                  if (this.modelPaths[part] != this.cModelPaths[part]) {
                      const modelPath = this.modelPaths[part];
                      this.cModelPaths[part] = modelPath;
                      const modelvalue = (
                      await manager.addFromPath(modelPath, {
                          autoCenter: false,
                          autoScale: false
                      })
                      )[0];
                      if (this.models[part]) {
                      this.models[part].modelObject.removeFromParent();
                      this.models[part] = undefined;
                      }
                      this.models[part] = modelvalue;
                      if (this.models[part]) {
                      this.root.modelObject.add(this.models[part].modelObject);
                      }
                  }
                }));
                await Promise.all(this.jsonData.map(async d => {
                  if (d.option_type == 'material') {
                      const colorFile = d.option_value;
                      const fileExt = colorFile?.split('.')[colorFile?.split('.').length - 1];
                      if (fileExt == 'pmat') await this.setMetalMaterial(colorFile, d.option_identifier);
                      else await this.setDiamondMaterial(colorFile, d.option_identifier);
                  }else if(d.option_type == 'engrave') {
                    if(!this.simpleText) {
                        this.simpleText = await this.viewer.addPlugin(SimpleTextPlugin);
                        this.simpleText.applyToAlphaMap = true;
                        this.simpleText.inverseAlphaMap = true;
                        //this.fontStyles = (await fetch("https://fonts.googleapis.com/css2?family=Aboreto&family=Dancing+Script&family=Inter&family=Montserrat&family=Nunito&family=Sacramento&display=swap")).text();
                    }
                    let state = {
                        text: d.option_value.text,
                        fontSize: d.option_value?.size ?? 150,
                        textColor: d.option_value.textColor ?? "#000000",
                        xOffset: d.option_value.xOffset ?? 0,
                        yOffset: d.option_value.yOffset ?? 0,
                        height: d.option_value.height ?? 1800
                    }
            
                    const decalObject = this.viewer.scene.getObjectByName('metal-engraving');
                    console.log({state,decalObject});
                    this.simpleText.updateText(decalObject, {...state});
            
                  }
                }));
                this.viewer.scene.setDirty();
            }

            async changeAutoRotate(flag=true) {
                //const autoRotate = this.viewer.scene.activeCamera.controls.autoRotate;
                this.viewer.scene.activeCamera.controls.autoRotate = flag;
            }
            async changeAutoRotateSpeed(speed = 2) {
                this.viewer.scene.activeCamera.controls.autoRotateSpeed = speed;
            }
            async changeCameraAngle(x,y,z) {
              //this.viewer.scene.activeCamera.position.set(x, y, z);
              //this.viewer.scene.activeCamera.positionUpdated();
              if(this.viewer && this.viewer.scene){
                  const camViewPlugin = this.viewer.getPlugin(CameraViewPlugin);
                  let view = camViewPlugin.getCurrentCameraView(this.viewer.scene.activeCamera);
                  view.position.set(x, y, z);
                  camViewPlugin.camViews.push(view);
                  await camViewPlugin.animateToView(camViewPlugin.camViews[camViewPlugin.camViews.length-1], 1500);
              }
            }

            checkForMobile = () => {
                let check = false;
                (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera)
                return check
            };
                
            setupThreeDCanvas = (viewer) => {
                if (!this.checkForMobile()) {
                this.viewer.renderer.displayCanvasScaling = 2;
                } else {
                this.viewer.renderer.displayCanvasScaling = Math.min(this.devicePixelRatio, 2);
                }
            };
            
            resetAllVariables(){
                this.pureWhiteBg = true;
                this.jsonData = [];
                this.modelPaths = {};
                this.cModelPaths = {};
                this.models = {};
                this.parts = [];
                this.root;
                this.viewerLoaded = false;
                this.viewer = null;
                this.vjsonFile = '';
            }
            
    }

function generateThreeDMediaArray(head, shank, metal_head, metal_shank, dmat, includeHand) {
  //const handModel = "https://cdn.shopify.com/3d/models/63298b834c0fe478/OnlyHand.glb";
  const handModel = "https://cdn.shopify.com/3d/models/d28b0c20d8a8434d/FinalHand.glb";
  const handMaterial = "https://cdn.shopify.com/s/files/1/0913/9354/files/1727260060383-vdb-HandColor.pmat?v=1756196933";
  
    
      var arr = [
        {
          "option_type": "model",
          "option_value": head,
          "option_identifier": "head"
        },
        {
          "option_type": "model",
          "option_value": shank,
          "option_identifier": "shank"
        },
        {
          "option_type": "material",
          "option_value": metal_head,
          "option_identifier": "metal-head,Head"//metal-head
        },
        {
          "option_type": "material",
          "option_value": metal_shank,
          "option_identifier": "Head,Metal_01,Engraving,metal-head,metal-insert,metal-shank,metal_shank"
        },
        {
          "option_type": "material",
          "option_value": dmat,
          "option_identifier": "stone-round,Main_Stones,Gem 01,Main_Stone"
        }
      ];
      
      if (includeHand) {
        arr.push(
          { option_type: 'model', option_value: handModel, option_identifier: 'hand' },
          { option_type: 'material', option_value: handMaterial, option_identifier: 'handcolor' }
        );
      }


      const engravedText = document.querySelector('#engraving-text')?.value || "";

      arr.push({
          option_type: "engrave",
          option_value: {
              size: 100,
              text: engravedText,
              textColor: "#000000",
              xOffset: 0,
              yOffset: 0,
              height: 2000,
          },
          option_identifier: "metal-engraving, Engraving",
      });

      console.log(arr);
      return arr;
    }
   
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('#Anillo_completo_btn');
  btn.addEventListener('click', handleAddToCart);
  viewimgopen();
  setupEngravingInputBox();

  // Set up view toggle buttons if they exist
  const viewOptions = document.querySelector('.view-options-slider');
  if (viewOptions) {
    const handView = document.getElementById('hand-view-btn');
    const ringtView = document.getElementById('3d-view-btn');
      if (handView) {
        handView?.addEventListener('click', () => toggleView('hand'));
      }
      if (ringtView) {
        ringtView.addEventListener('click', () => toggleView('ring'));
      }
    }
});

let debounceTimer;

function setupEngravingInputBox() {
  const engravingInput = document.querySelector('#engraving-text');
  const engravingInputRemainingCount = document.querySelector('.char-limit span');

  engravingInput.addEventListener("input", (e) => {
    engravingInputRemainingCount.innerHTML = 18 - engravingInput.value.length;

    debounceTimer = setTimeout(() => {
      console.log("Debounced value:", e.target.value);
      if (currentViewMode == 'ring') {
        updateRingViewer();
      }
    }, 500);
});
  
}

function vdbSetUrlParams(key, value) {
  url.searchParams.set(key, value);
  window.history.pushState(null, "", url.toString());
}